const isLocalhost = Boolean(
	window.location.hostname === 'localhost' ||
		window.location.hostname === '[::1]' ||
		window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// How often a foregrounded app re-checks for a new deploy. An installed PWA can
// stay open for days without ever issuing a fresh navigation, which is the only
// other moment the browser would look for a new worker on its own.
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000;

let reloading = false;

export function register() {
	if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
		const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
		if (publicUrl.origin !== window.location.origin) return;

		window.addEventListener('load', () => {
			const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

			if (isLocalhost) {
				checkValidServiceWorker(swUrl);
			} else {
				registerValidSW(swUrl);
			}
		});
	}
}

// The new worker took over: swap the page onto it so the user is looking at the
// freshly precached shell instead of the one this document was booted from.
function reloadOnce() {
	if (reloading) return;
	reloading = true;
	window.location.reload();
}

function activateWaitingWorker(registration) {
	if (!registration.waiting) return;
	// Only the controlled case needs a reload; on a first install there is no
	// stale document to replace and clientsClaim() already handles the takeover.
	if (navigator.serviceWorker.controller) {
		navigator.serviceWorker.addEventListener('controllerchange', reloadOnce);
	}
	registration.waiting.postMessage({ type: 'SKIP_WAITING' });
}

function scheduleUpdateChecks(registration) {
	let lastCheck = Date.now();

	const check = () => {
		if (document.visibilityState !== 'visible') return;
		if (Date.now() - lastCheck < UPDATE_CHECK_INTERVAL_MS) return;
		lastCheck = Date.now();
		registration.update().catch(() => {
			/* offline: the next foreground check will retry */
		});
	};

	document.addEventListener('visibilitychange', check);
	setInterval(check, UPDATE_CHECK_INTERVAL_MS);
}

function registerValidSW(swUrl) {
	navigator.serviceWorker
		.register(swUrl)
		.then((registration) => {
			// A worker left waiting by an earlier visit — activate it now rather
			// than serving the old shell for another session.
			activateWaitingWorker(registration);

			registration.onupdatefound = () => {
				const installingWorker = registration.installing;
				if (!installingWorker) return;
				installingWorker.onstatechange = () => {
					if (installingWorker.state === 'installed') {
						activateWaitingWorker(registration);
					}
				};
			};

			scheduleUpdateChecks(registration);
		})
		.catch((error) => {
			console.error('Error during service worker registration:', error);
		});
}

function checkValidServiceWorker(swUrl) {
	fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
		.then((response) => {
			const contentType = response.headers.get('content-type');
			if (response.status === 404 || (contentType && !contentType.includes('javascript'))) {
				navigator.serviceWorker.ready.then((registration) => {
					registration.unregister().then(() => window.location.reload());
				});
			} else {
				registerValidSW(swUrl);
			}
		})
		.catch(() => {
			console.log('No internet connection. App is running in offline mode.');
		});
}

export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => registration.unregister())
			.catch((error) => console.error(error.message));
	}
}
